import { differenceInYears } from 'date-fns';
/**
 * Code passager d'un voyageur, calculé à la date du VOYAGE et non à aujourd'hui : un
 * voyageur qui change de tranche d'ici le départ doit partir sous son code du jour J.
 *
 * Bornes de l'agence : < 2 ans bébé · < 12 ans enfant · < 25 ans jeune · < 60 ans adulte ·
 * au-delà sénior.
 */
export function resolvePassengerTypeCode(birthDate, referenceDate) {
    // Date inexploitable (saisie en cours, date de voyage absente) : on retombe sur adulte,
    // le code par défaut du reste de la chaîne — jamais sur sénior, ce que donnerait un NaN
    // laissé filer dans les comparaisons ci-dessous.
    if (Number.isNaN(birthDate.getTime()) || Number.isNaN(referenceDate.getTime()))
        return 'ADT';
    const age = differenceInYears(referenceDate, birthDate);
    if (age < 2)
        return 'INF';
    if (age < 12)
        return 'CHD';
    if (age < 25)
        return 'YTH';
    if (age < 60)
        return 'ADT';
    return 'YCD';
}
/**
 * Codes passagers d'une liste de voyageurs, dans leur ordre de saisie.
 *
 * L'ordre compte : les sélecteurs « Passager 1, 2, 3… » du formulaire de réponse lisent
 * ce tableau par index.
 */
export function resolvePassengerTypeCodes(passengers, referenceDate) {
    return passengers.map((passenger) => resolvePassengerTypeCode(new Date(passenger.birthDate), referenceDate));
}
/**
 * Date de départ du voyage demandé — la référence des tranches d'âge, côté serveur comme
 * ici. Repli sur aujourd'hui quand la demande n'a pas encore de date exploitable.
 */
export function resolveTravelDepartureDate(value) {
    const raw = value.estimateType === 'FLIGHT'
        ? (value.flights ?? [])
            .map((leg) => leg.date)
            .filter(Boolean)
            .sort()[0]
        : value.departureDate;
    if (!raw)
        return new Date();
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? new Date() : parsed;
}
